interface WindowPopperListener {
  onShow(deviceId?: string): void
  onClose(): void
}

export class WindowPopperManager {
  #windowPopperListener: WindowPopperListener | undefined

  setChangeListener(listener: WindowPopperListener): void {
    this.#windowPopperListener = listener
  }

  show(deviceId?: string): void {
    this.#windowPopperListener?.onShow(deviceId)
  }

  close(): void {
    this.#windowPopperListener?.onClose()
  }
}

const INSTANCE = new WindowPopperManager()

export { INSTANCE }
